import gql from "graphql-tag"

const visitorAccessCacheFragment = gql`
  fragment visitorAccessCacheFragment on Site {
    previewPassword
    previewProtection
  }
`

export function updateVisitorAccessCache(
  siteId,
  { previewPass, previewProtect }
) {
  return proxy => {
    const fragmentInfo = {
      id: `Site:${siteId}`,
      fragment: visitorAccessCacheFragment,
    }
    const siteFrag = proxy.readFragment(fragmentInfo)

    if (previewPass) {
      siteFrag.previewPassword = previewPass
    }

    siteFrag.previewProtection = previewProtect

    proxy.writeFragment({
      ...fragmentInfo,
      data: siteFrag,
    })
  }
}
